<template lang="pug">
div
  //- BARRA de titulo
  v-app-bar(:elevation="0")
    v-toolbar-title
      v-card-title.pl-1.pb-4 Filtro

    v-spacer

    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          v-bind="attrs"
          v-on="on"
          icon
          @click="clearFilter()"
        )
          v-icon mdi-broom
      span
        span.text-md.font-weight-medium Limpar Filtro
        br
        span.font-weight-light Limpa o conteúdo dos campos de filtro.

    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          v-bind="attrs"
          v-on="on"
          icon
          @click="$emit('input',!value)"
        )
          v-icon mdi-close
      span
        span.text-md.font-weight-medium Esconde o Filtro
        br
        span.font-weight-light Esconde a caixa de filtragem da grade.

  //- FORMULARIO de filtragem
  v-form(
    ref="form"
    @submit.prevent="search"
  )

    v-card-text.pb-0
      v-row.mb-2
        v-col.d-flex.justify-space-between(cols="12")

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn.flex-grow-1(
                v-bind="attrs"
                v-on="on"
                color='primary'
                small
                @click="search"
              )
                v-icon(left) mdi-refresh
                | Aplicar
            span
              span.text-md.font-weight-medium Aplica o Filtro
              br
              span.font-weight-light Atualiza a grade de registros com o resultado da aplicação do filtro.

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              div(
                v-bind="attrs"
                v-on="on"
              )
                widget-rows-per-page.ml-2(
                  v-if="limitField"
                  ref="widget"
                  v-model="limitField.value"
                  :field="limitField"
                  outlined
                  super-dense
                  @action-performed="search"
                )
            span
              span.text-md.font-weight-medium Limite de Registros
              br
              span.font-weight-light Define o número de registros a serem recuperados do servidor de dados.

    div.pt-2(style="height:calc(100vh - 260px); overflow-y: auto; overflow-x: hidden;")

      div
        v-card-text.pb-1
          widget(
            ref="widget"
            v-for="field in otherFields"
            v-model="field.value"
            :key="field.name"
            :field="field"
            :hidden="isSearchField(field)"
            :context="expressionContext"
            outlined
            dense
            @action-performed="search"
          )
</template>

<script>
import { hasRel } from '@/helpers/rels'
import Vue from 'vue'
import GridExFilterBtn from './GridExFilterBtn'
import Widget from '@/components/widgets/Widget'
import WidgetRowsPerPage from '@/components/widgets/WidgetRowsPerPage'
import { computeAll } from '@/helpers/conditions'
import { parseEref } from '@/helpers/erefs'

export default {
  components: {
    GridExFilterBtn,
    Widget,
    WidgetRowsPerPage,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,
  },

  computed: {
    rawFields() {
      const items = this.filter?.fields || []
      items.map(field => Vue.set(field, 'value', field.value))
      return items
    },

    fields() {
      const items = this.rawFields
      computeAll(items, this.context)
      return items.filter(item => !item.hidden)
    },

    limitField() {
      return this.fields.find(field => hasRel(field, "Limit"))
    },

    otherFields() {
      return this.fields.filter(field => !hasRel(field, "Limit"))
    },

    // Retorna um objeto contendo os campos válidos que podem ser usados em um contexto
    // de expressão dinâmica.
    formData() {
      const items = this.rawFields
      const result = {}

      items.forEach(item => {
        if (item.name) {
          // Usando Vue.set para garantir que as propriedades sejam reativas
          this.$set(result, item.name, item.value)
        }
      })

      return result
    },

    // Contexto para resolução de expressões com /helpers/expression.js.
    expressionContext() {
      return {
        site: this.site,
        eref: parseEref(this.eref),
        page: this.entity,
        data: this.data,
        form: this.formData,
        row: null
      }
    },

    // [OBSOLETO] Este contexto é usado para interpolação de texto.
    // Porém, substituímos este método pela nova forma com /helpers/expressions.js.
    context () {
      const context = {}
      const items = this.filter?.fields || []
      items.map(field => context[field.name] = field.value)

      // const { site, eref, entity, filter, value } = this.$props
      const { eref, entity } = this.$props

      // SRef contém a forma completa da referência da entidade.
      // Por exemplo, mesmo que um ERef tenha essa forma simplificada:
      //    Site.Apis.Endpoints(CupomVerde)
      // O SRef conterá a forma completa:
      //    Site.Apis.Endpoints(Api=CupomVerde)
      // Dessa forma é possível saber os parâmetros da página.
      // const [name, pairs] = (entity?.sref || eref).replace(')', '').split('(')
      const [_, pairs] = (entity?.sref || eref).replace(')', '').split('(')
      // const args = {}

      if (pairs?.includes('=')) {
        // Vamos quebrar os parâmetros e repassar cada um para o contexto.
        const params = pairs.split(',');
        // Processa cada par chave=valor
        params.forEach(param => {
          const [key, value] = param.trim().split('=');
          // Adiciona cada parâmetro ao contexto
          context[key.toCamelCase()] = value;
          // args[key.toCamelCase()] = value;
        });
      }

      // context.eref = { site, name, args }
      // context.props = { site, eref, entity, filter, value }

      return context
    },
  },

  methods: {
    clearFilter (reset) {
      const { form, widget: widgets } = this.$refs

      form.resetValidation()
      widgets.forEach(widget => {
        reset ? widget.field?.reset() : widget.field?.clear()
      })
    },

    isSearchField (field) {
      return field.rel?.includes('Search')
    },

    search () {
      if (this.$refs.form.validate()) {
        this.$emit('refresh')
      }
    },

    queryOnView() {
      if (this.entity?.queryOnView && !this.entity.dataSet?.sets?.length) {
        this.$nextTick(function () { this.search() })
      }
    },
  },

  mounted() {
    this.queryOnView();
  },
}
</script>